<!-- Header -->
<header class="header">
  <nav class="nav container">
    <a href="" class="nav__logo">Giovanni Ferdinando Izzi</a>
    <div class="nav__menu" id="nav-menu" [ngClass]="{'show-menu': toggleNav === true, 'hide-menu': toggleNav === false}">
      <ul class="nav__list grid">
        <li class="nav__item">
          <a href="#home" class="nav__link" (click)="onClickItem()">
            <i class="uil uil-estate nav__icon"></i> Home
          </a>
        </li>
        <li class="nav__item">
          <a href="#about" class="nav__link" (click)="onClickItem()">
            <i class="uil uil-user nav__icon"></i> About
          </a>
        </li>
        <li class="nav__item">
          <a href="#skills" class="nav__link" (click)="onClickItem()">
            <i class="uil uil-user nav__icon"></i> Skills
          </a>
        </li>
        <li class="nav__item">
          <a href="#qualification" class="nav__link" (click)="onClickItem()">
            <i class="uil uil-briefcase-alt nav__icon"></i> Qualification
          </a>
        </li>
        <li class="nav__item">
          <a href="#portfolio" class="nav__link" (click)="onClickItem()">
            <i class="uil uil-briefcase-alt nav__icon"></i> Portfolio
          </a>
        </li>
        <li class="nav__item">
          <a href="#contact" class="nav__link" (click)="onClickItem()">
            <i class="uil uil-message nav__icon"></i> Contact Me
          </a>
        </li>
      </ul>
      <i class="uil uil-times nav__close" (click)="onClickNavToggle()"></i>
    </div>
    <div class="nav__btns">
      <!-- Theme Change -->
      <div (click)="onClickChangeTheme()">
        <i class="uil uil-moon change-theme" id="theme-button"></i>
      </div>

      <div class="nav__toggle" (click)="onClickNavToggle()">
        <i class="uil uil-apps"></i>
      </div>
    </div>
  </nav>
</header>

